import { Typography } from "@mui/material";
import { loginStore } from "../state/CommonState";

export function WelcomeCard(){
    return   <span style={{ height: "6%", display: "flex", justifyContent: "start", alignItems: "center" }}>
    <Typography sx={{ color: "#2B6ED4" }}><span style={{ color: "black", fontWeight: "bold" }}>Welcome,</span>{" " + loginStore.userRec.firstName}</Typography>
</span>
}